/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardHead from '../components/card-header.js';
import CardBody from '../components/card-body.js';
import ClassesService from '../services/classes-service.js';
import ClassesStore from '../store/classes-store.js';
import Select from  'react-select';
import {Collapse , Checkbox , Button , FormControl , Form , FormGroup , ControlLabel ,  Table , Row , Col} from 'react-bootstrap';
import ContentNavigation from '../classes/content-navigation.js';
import ClassSelector from '../components/inputs/classes-selector.js';
import LanguageStore from '../store/language-store.js';
import CurriculumService from '../services/curriculums-services.js'
import ScoresService from '../services/scores-services.js';
import ModulesStore from '../store/screen-store.js';
import CDNImage from '../components/media/image.js';
import InternationalizationStore from '../store/internationalization-store.js';
import LanguageSelector from "../components/inputs/language-selector.js";
import ModuleService from '../services/screens-service.js';
import DataSelector from '../components/inputs/date.input.js';
import ModulesStudentScores from '../components/tables/modules-tests-students-table.js';

const depthOf = function(object, level){
    // Returns an int of the deepest level of an object
    level = level || 1;

    var key;
    for(key in object){
        if (!object.hasOwnProperty(key)) continue;

        if(typeof object[key] == 'object'){
            level++;
            level = depthOf(object[key], level);
        }
    }

    return level;
};

export default class ClassScoresWidget extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.methodOptions = [this.getStandardOptions('Language Course', 'Language Course' , null) , this.getStandardOptions('Topics' , 'Topics' , null) , this.getStandardOptions('Assignments' , 'Assignments' , null)];

        var to =   new Date();
        var from = new Date();
        from.setDate(from.getDate() - 14);


        this.state = {
            classes : [],
            selectedLanguage:null,
            selectedClass:{value:this.props.classID},
            selectedCurriculum:null,
            selectedModules:[],
            moduleTiers:[],
            curriculums:null,
            method:this.methodOptions[0],
            tests:true,
            games:false,
            gamesDisabled:true,
            showSearch:true,
            to: to.toISOString(),
            from:from.toISOString(),
        };


        this.handelLanguageSelection = this.handelLanguageSelection.bind(this);
        this.handelDateToSelect     = this.handelDateToSelect.bind(this);
        this.handelDateFromSelect = this.handelDateFromSelect.bind(this);
    }

    componentDidMount(){

    }

    componentWillMount(){

    }

    getStandardOptions(value , label , object){
        return {value:value , label:label , object:object};
    }

    handelLanguageSelection(language , totalLanguages){

        var curriculums = language.getCurriculums();
        var curriculumObject = this.getStandardOptions(curriculums[0].uid , curriculums[0].getName() , curriculums[0])

        this.setState({curriculums:curriculums , selectedLanguage:language , multipleCurriculums:curriculums.length > 1 ,  hideLanguageOptions:totalLanguages == 1});
        this.handelCurriculumSelection(curriculumObject);
    }

    handelCurriculumSelection(curriculum){
        this.setState({selectedCurriculum:curriculum});

        CurriculumService.getCurriculumData(curriculum.value).then(function(curriculumData){
            ModuleService.getModules(curriculumData.startScreen).then(function(response){

                ModulesStore.modules = ModulesStore.processModules(response);
                var modules =  ModulesStore.getArray();

                function flat(data){
                    var r = [];

                    for(var idx = 0 ; idx < data.length; idx++){
                         if(data[idx].catalog_uid != null) r.push(data[idx]);
                         if(data[idx].subModules.length > 0) r = r.concat(flat(data[idx].subModules))
                    }

                    return r;
                }

                this.setState({modules:flat(modules)})
                this.handelSubmit();
            }.bind(this));
        }.bind(this));
    }

    handelMethodSelection(method){
        this.setState({method:method})
    }

    handelClassSelection(classes){
        this.setState({selectedClass:classes});
    }

    shouldRenderCurriculum(){
        if(!this.state.multipleCurriculums) return;

        const curriculumOptions = this.state.curriculums.map(function(curriculum){
            return  this.getStandardOptions(curriculum.uid , curriculum.getName() , curriculum);
        }.bind(this));

        return  <Select className={""}  onChange={this.handelClassSelection} value={this.state.selectedCurriculum} options={curriculumOptions} 
                noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

    getLanguage(){
        if(!this.state.selectedLanguage) return null
        return this.state.selectedLanguage.ietf
    }

    handelDateToSelect(value){
        this.setState({to:value});
        this.handelSubmit();
    }

    handelDateFromSelect(value){
        this.setState({from:value});
        this.handelSubmit();
    }

    handelSubmit(){

        ScoresService.getStudentScores(this.props.studentID ,  this.getLanguage() , this.state.from , this.state.to).then(function(data){
            this.setState({data:data})
        }.bind(this));
    }

    handelSearchToggel(){
        this.setState({showSearch:!this.state.showSearch})
    }


    render(){

        const NavigationRows = this.state.moduleTiers.map(function(item , index){
            const label = index == 0 ?  <ControlLabel>Filter</ControlLabel> :  <ControlLabel></ControlLabel>;
            return <Col sm={6}><FormGroup>{label} {item()}</FormGroup></Col>

        });


        return <div>
                    <Collapse in={false} >
                        <Row>
                            <Col sm={4}>
                                <Button onClick={this.handelSearchToggel.bind(this)} className="btn-primary btn-block" >Search</Button>
                            </Col>
                        </Row>
                    </Collapse>
                    <Collapse in={true} >
                        <div >
                            <Row>
                                <Col sm={4} className={this.state.hideLanguageOptions ? "hide" : ""}>
                                    <FormGroup>
                                        <ControlLabel><FormattedMessage id={ 'ui-847' } defaultMessage={ 'Choose class' }/></ControlLabel>
                                        <LanguageSelector onSelect={this.handelLanguageSelection}/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {this.shouldRenderCurriculum()}
                            <Row>
                                {NavigationRows}
                            </Row>
                            <Row>
                                <Col  sm={6}>
                                    <FormGroup className="fg-line">
                                        <DataSelector onSelect={this.handelDateFromSelect.bind(this)} value={this.state.from}  labelTranslationUID="ui-698" labelName="From"/>
                                    </FormGroup>
                                </Col>
                                <Col  sm={6}>
                                    <FormGroup className="fg-line">
                                        <DataSelector onSelect={this.handelDateToSelect.bind(this)} value={this.state.to}  labelTranslationUID="ui-699" labelName="to"/>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    </Collapse>
                    <Row>
                        <ModulesStudentScores data={this.state.data} modules={this.state.modules}/>
                    </Row>
            </div>

    }

}




// WEBPACK FOOTER //
// ./src/components/student-scores-widget.js